"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeBoxShadow = exports.convertToRGB = exports.TextAlignEnums = exports.PositionPlaceEnums = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const hooks_1 = require("../../utils/hooks");
const text_1 = require("../../utils/text");
const tooltip_1 = __importDefault(require("./tooltip"));
const globalStyle_1 = __importDefault(require("../../style/globalStyle"));
const infoTooltip_style_1 = __importDefault(require("./infoTooltip.style"));
var PositionPlaceEnums;
(function (PositionPlaceEnums) {
    PositionPlaceEnums["top"] = "top";
    PositionPlaceEnums["right"] = "right";
    PositionPlaceEnums["bottom"] = "bottom";
    PositionPlaceEnums["left"] = "left";
})(PositionPlaceEnums = exports.PositionPlaceEnums || (exports.PositionPlaceEnums = {}));
var TextAlignEnums;
(function (TextAlignEnums) {
    TextAlignEnums["center"] = "center";
    TextAlignEnums["left"] = "left";
    TextAlignEnums["right"] = "right";
    TextAlignEnums["justify"] = "justify";
})(TextAlignEnums = exports.TextAlignEnums || (exports.TextAlignEnums = {}));
const convertToRGB = (hex) => {
    const newHex = hex.replace('#', '');
    if (newHex.length !== 6) {
        console.warn('only six-digit hex colors are allowed.');
    }
    const aRgbHex = newHex.match(/.{1,2}/g);
    const aRgb = [
        parseInt(aRgbHex[0], 16),
        parseInt(aRgbHex[1], 16),
        parseInt(aRgbHex[2], 16)
    ];
    return aRgb;
};
exports.convertToRGB = convertToRGB;
const computeBoxShadow = (color, opacity) => {
    if (opacity > 10 || opacity < 0) {
        console.error('only range 0-10 is allowed');
    }
    // static box shadow positioning
    const position = '0px 3px 20px';
    const rgba = exports.convertToRGB(color);
    return `${position} rgba(${rgba.join(', ')}, ${opacity / 10})`;
};
exports.computeBoxShadow = computeBoxShadow;
const InfoTooltip = ({ classes, dataCy = 'info-tooltip', text, textAlign = TextAlignEnums.left, textColor = globalStyle_1.default.white1, backgroundColor = globalStyle_1.default.grey2, padding = '10px 20px', children, position = {
    place: PositionPlaceEnums.right,
    placeShift: 3,
    adjustPlace: true
}, delay = 100, minWidth = 100, maxWidth = 200, boxShadowColor = '', boxShadowOpacity = 0, onClick = false, includeTooltipInWrapper = false }) => {
    const [showTooltip, setShowTooltip] = react_1.useState(false);
    const tooltipWrapperRef = react_1.useRef(null);
    // allow to specify theme colors
    const usedBackgroundColor = globalStyle_1.default[backgroundColor] || backgroundColor;
    const usedTextColor = globalStyle_1.default[textColor] || textColor;
    const usedBoxShadow = react_1.useMemo(() => {
        if (boxShadowOpacity === 0)
            return 'unset';
        return exports.computeBoxShadow(boxShadowColor || usedBackgroundColor, boxShadowOpacity);
    }, [boxShadowColor, boxShadowOpacity, usedBackgroundColor]);
    hooks_1.useOnClickOutside(tooltipWrapperRef, () => onClick && setShowTooltip(false));
    const handleMouseEnter = react_1.useCallback(() => !onClick && setShowTooltip(true), [onClick]);
    const handleMouseLeave = react_1.useCallback(() => !onClick && setShowTooltip(false), [onClick]);
    const handleClick = react_1.useCallback(() => onClick && setShowTooltip(!showTooltip), [onClick, showTooltip]);
    const rootProps = {
        'data-cy': dataCy,
        className: classes.tooltipWrapper,
        ref: tooltipWrapperRef,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleClick
    };
    const tooltip = showTooltip && (jsx_runtime_1.jsx(tooltip_1.default, Object.assign({ clientEl: tooltipWrapperRef.current, portalEl: document.body, position: position, arrowUp: jsx_runtime_1.jsx("div", { className: classes.infoTooltipArrowUp, style: {
                borderBottomColor: usedBackgroundColor,
                boxShadow: usedBoxShadow
            } }, void 0), delay: delay }, { children: jsx_runtime_1.jsx("p", Object.assign({ className: classes.infoTooltipBody, style: {
                color: usedTextColor,
                backgroundColor: usedBackgroundColor,
                boxShadow: usedBoxShadow,
                minWidth,
                maxWidth,
                textAlign,
                padding
            } }, { children: text_1.parseBoldMarkdown(text) }), void 0) }), void 0));
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsxs("div", Object.assign({}, rootProps, { children: [children, includeTooltipInWrapper && tooltip] }), void 0), !includeTooltipInWrapper && tooltip] }, void 0));
};
exports.default = react_jss_1.default(infoTooltip_style_1.default)(InfoTooltip);
//# sourceMappingURL=index.js.map